// src/components/CharacterSpawner/SingleCharacterSpawner.tsx
import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { CustomImageView } from "./CustomImageView";

// // 1. Import the images directly from your assets folder
import char1 from "../../assets/images/characters/daam-c1.png";
import char2 from "../../assets/images/characters/daam-c2.png";
import char3 from "../../assets/images/characters/daam-c3.png";
import char4 from "../../assets/images/characters/daam-c4.png";
import char5 from "../../assets/images/characters/daam-c5.png";
import char6 from "../../assets/images/characters/daam-c6.png";
import char7 from "../../assets/images/characters/daam-c7.png";
import char8 from "../../assets/images/characters/daam-c8.png";
import char9 from "../../assets/images/characters/daam-c9.png";
import char10 from "../../assets/images/characters/daam-c10.png";
import useWindowDimensions from "../../core/utils/UseWindowDimensions";

// Defines how we pass coordinates
export interface Coordinate {
  top?: string | number;
  left?: string | number;
  right?: string | number;
  bottom?: string | number;
}

// All available game character images
export const ALL_CHARACTER_IMAGES = [
  char1,
  char2,
  char3,
  char4,
  char5,
  char6,
  char7,
  char8,
  char9,
  char10,
];

interface SingleSpawnerProps {
  /** The allowed random spots for this specific screen */
  allowedLocations: Coordinate[];
}

export const RandomCharacterSpawner: React.FC<SingleSpawnerProps> = ({
  allowedLocations,
}) => {
  const [spawnedEntity, setSpawnedEntity] = useState<{
    img: string;
    pos: Coordinate;
  } | null>(null);

  useEffect(() => {
    // Safety check
    if (allowedLocations.length === 0 || ALL_CHARACTER_IMAGES.length === 0)
      return;

    // Pick random image and location
    const randomImageIndex = Math.floor(
      Math.random() * ALL_CHARACTER_IMAGES.length,
    );
    const randomLocIndex = Math.floor(Math.random() * allowedLocations.length);

    setSpawnedEntity({
      img: ALL_CHARACTER_IMAGES[randomImageIndex],
      pos: allowedLocations[randomLocIndex],
    });
  }, []);

  const { width } = useWindowDimensions();

  const isMobile = width < 1200;
  const size = isMobile ? 100 : 150;
  return (
    <Box
      sx={{
        position: "absolute",
        inset: 0, // Shorthand for top: 0, right: 0, bottom: 0, left: 0
        pointerEvents: "none", // Lets users click through the overlay
        zIndex: 50,
        overflow: "hidden",
      }}
    >
      {/* {allowedLocations.map((loc, index) => {
        const spawnedEntity = {
          img: ALL_CHARACTER_IMAGES[index],
          pos: loc,
        };
        return (
          <CustomImageView
            src={spawnedEntity.img}
            width={size}
            height={size}
            props={{
              position: "absolute",
              top: spawnedEntity.pos.top,
              left: spawnedEntity.pos.left,
              right: spawnedEntity.pos.right,
              bottom: spawnedEntity.pos.bottom,
            }}
          />
        );
      })} */}
      {spawnedEntity && (
        <CustomImageView
          src={spawnedEntity.img}
          width={size}
          height={size}
          props={{
            position: "absolute",
            top: spawnedEntity.pos.top,
            left: spawnedEntity.pos.left,
            right: spawnedEntity.pos.right,
            bottom: spawnedEntity.pos.bottom,
          }}
        />
      )}
    </Box>
  );
};
